import { Bars, Fallback, FAQ, Points, Referrals, Stake, Play } from "@sections";

import * as IC from "@icons";

import type { Route } from "@types";

export const routes: Route[] = [
  {
    name: "default",
    route: "/",
    description: "",
    weight: 50,
    component: Stake,
    icon: IC.StackAndBall,
  },

  {
    name: "Stake",
    route: "/stake",
    description: "",
    weight: 50,
    component: Stake,
    icon: IC.StackAndBall,
  },
  {
    name: "Stake/Stake",
    route: "/stake/stake",
    description: "",
    weight: 50,
    component: Stake,
    icon: IC.StackAndBall,
  },
  {
    name: "Stake/Balances",
    route: "/stake/balances",
    description: "",
    weight: 50,
    component: Stake,
    icon: IC.StackAndBall,
  },

  // { name: "Points", route: "/points", description: "" , weight: 40, component: Points, icon: IC.UserStar, },
  // { name: "Points/Leaderboard", route: "/points/leaderboard", description: "" , weight: 40, component: Points, icon: IC.UserStar, },
  // { name: "Points/MyPoints", route: "/points/mypoints", description: "" , weight: 40, component: Points, icon: IC.UserStar, },
  // { name: "Points/Boosts", route: "/points/boosts", description: "" , weight: 40, component: Points, icon: IC.UserStar, },

  {
    name: "Bars",
    route: "/bars",
    description: "",
    weight: 40,
    component: Bars,
    icon: IC.UserStar,
  },
  {
    name: "Bars/Leaderboard",
    route: "/bars/leaderboard",
    description: "",
    weight: 40,
    component: Bars,
    icon: IC.UserStar,
  },
  {
    name: "Bars/Boosts",
    route: "/bars/boosts",
    description: "",
    weight: 40,
    component: Bars,
    icon: IC.UserStar,
  },
  {
    name: "Play",
    route: "/play",
    description: "",
    weight: 30,
    component: Play,
    icon: IC.PlayIcon,
    disabled:
      window.location.search.includes("feature=in-out") ||
      Math.floor(Date.now() / 1000) >= 1726059600
        ? false
        : true,
  },
  {
    name: "Stats",
    route: "/stats",
    description: "",
    weight: 20,
    component: Fallback,
    icon: IC.ChartBars,
  },
  {
    name: "FAQ",
    route: "/faq",
    description: "",
    weight: 10,
    component: FAQ,
    icon: IC.CircledQuestion,
  },
  {
    name: "Referrals",
    route: "/referrals",
    description: "",
    weight: 10,
    component: Referrals,
    icon: IC.TriWork,
  },
];
